/* Dialed-IN Clean LP (v3) behaviour: bundles, checkout links, gallery, rails, ticker, fade-in, sticky bar. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function init(root) {
    if (root.__dcl) return;
    root.__dcl = true;

    /* ---------- bundles ---------- */
    var opts = [].slice.call(root.querySelectorAll('[data-dcl-opt]'));
    var qtyIns = root.querySelectorAll('[data-dcl-qty]');
    var mains = root.querySelectorAll('[data-dcl-main]');
    var prices = root.querySelectorAll('[data-dcl-price]');
    var saveBox = root.querySelector('[data-dcl-save]');
    var saveT = root.querySelector('[data-dcl-save-title]');
    var saveS = root.querySelector('[data-dcl-save-sub]');
    var stL = root.querySelector('[data-dcl-sticky-label]');
    var stS = root.querySelector('[data-dcl-sticky-sub]');
    var useCookie = root.hasAttribute('data-dcl-cookie');
    var lastCode = null;

    function applyCode(code) {
      if (!useCookie || !code || code === lastCode || !window.fetch) return;
      lastCode = code;
      fetch(rootPath + 'discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
    }

    function pick(o) {
      opts.forEach(function (x) {
        var on = x === o;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
      });
      var d = o.dataset;
      mains.forEach(function (a) { a.setAttribute('href', d.url); });
      prices.forEach(function (el) { el.textContent = d.now; });
      qtyIns.forEach(function (el) { el.value = d.qty; });
      if (saveBox) {
        saveBox.hidden = !d.saveTitle;
        if (saveT) saveT.textContent = d.saveTitle || '';
        if (saveS) saveS.textContent = d.saveSub || '';
      }
      if (stL) stL.textContent = d.title + ' · ' + d.now;
      if (stS) { stS.textContent = d.ship || ''; stS.classList.toggle('is-muted', d.free !== 'true'); }
      applyCode(d.code);
    }

    opts.forEach(function (o, i) {
      o.addEventListener('click', function () { pick(o); });
      o.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = opts[(i + 1) % opts.length];
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = opts[(i - 1 + opts.length) % opts.length];
        if (n) { e.preventDefault(); n.focus(); pick(n); }
      });
    });
    var start = root.querySelector('[data-dcl-opt].is-on') || opts[0];
    if (start) pick(start);

    /* ---------- straight-to-checkout links (beat theme cart drawers) ---------- */
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-dcl-go]') : null;
      if (!a || !root.contains(a)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.assign(a.getAttribute('href'));
    }, true);

    /* ---------- in-page anchors (no global smooth scroll: iOS eats touches) ---------- */
    root.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var t = id && document.getElementById(id);
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });

    /* ---------- gallery ---------- */
    [].forEach.call(root.querySelectorAll('[data-dcl-gal]'), function (g) {
      var st = g.querySelector('[data-dcl-stage]');
      if (!st) return;
      var n = st.children.length;
      var thumbs = g.querySelectorAll('[data-dcl-thumb]');
      var cnt = g.querySelector('[data-dcl-count]');
      var strip = g.querySelector('.dcl-gal__thumbs');
      if (n < 2) return;
      function cur() { return Math.round(st.scrollLeft / Math.max(1, st.clientWidth)); }
      function go(i) { i = (i + n) % n; st.scrollTo({ left: i * st.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
      function paint() {
        var i = Math.min(n - 1, Math.max(0, cur()));
        [].forEach.call(thumbs, function (t, j) {
          t.classList.toggle('is-on', j === i);
          t.setAttribute('aria-current', j === i ? 'true' : 'false');
        });
        if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
        var t = thumbs[i];
        if (strip && t) {
          var l = t.offsetLeft - strip.offsetLeft, r = l + t.offsetWidth;
          if (l < strip.scrollLeft) strip.scrollLeft = l - 4;
          else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = r - strip.clientWidth + 4;
        }
      }
      var p = g.querySelector('[data-dcl-prev]'), nx = g.querySelector('[data-dcl-next]');
      if (p) p.addEventListener('click', function () { go(cur() - 1); });
      if (nx) nx.addEventListener('click', function () { go(cur() + 1); });
      [].forEach.call(thumbs, function (t, j) { t.addEventListener('click', function () { go(j); }); });
      st.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur() - 1); }
      });
      var raf = 0;
      st.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }, { passive: true });
      paint();
    });

    /* ---------- rails (reviews, photos) ---------- */
    [].forEach.call(root.querySelectorAll('[data-dcl-rail]'), function (w) {
      var tr = w.querySelector('[data-dcl-track]');
      if (!tr) return;
      function step(dir) {
        var c = tr.firstElementChild;
        var dx = c ? c.getBoundingClientRect().width + 14 : 300;
        tr.scrollBy({ left: dir * dx * 2, behavior: reduce ? 'auto' : 'smooth' });
      }
      var a = w.querySelector('[data-dcl-rprev]'), b = w.querySelector('[data-dcl-rnext]');
      if (a) a.addEventListener('click', function () { step(-1); });
      if (b) b.addEventListener('click', function () { step(1); });
    });

    var hasIO = 'IntersectionObserver' in window;

    /* ---------- marquee: only animates while on screen ---------- */
    if (hasIO) {
      var mqs = root.querySelectorAll('[data-dcl-mq]');
      if (mqs.length) {
        var mio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { e.target.classList.toggle('is-paused', !e.isIntersecting); });
        });
        [].forEach.call(mqs, function (m) { mio.observe(m); });
      }
    }

    /* ---------- gentle reveal on scroll (content is visible without JS) ---------- */
    if (hasIO && root.hasAttribute('data-dcl-reveal') && !reduce && !(window.Shopify && window.Shopify.designMode)) {
      root.classList.add('dcl-js');
      var rio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      var pending = [].slice.call(root.querySelectorAll('.dcl-rv'));
      pending.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
        else rio.observe(el);
      });
      /* failsafes: never leave content hidden if an in-app browser skips an observer callback */
      var tick = 0;
      var sweep = function () {
        tick = 0;
        pending = pending.filter(function (el) {
          if (el.classList.contains('is-in')) return false;
          if (el.getBoundingClientRect().top < window.innerHeight * 1.05) { el.classList.add('is-in'); return false; }
          return true;
        });
        if (!pending.length) window.removeEventListener('scroll', onScroll);
      };
      var onScroll = function () { if (!tick) tick = requestAnimationFrame(sweep); };
      window.addEventListener('scroll', onScroll, { passive: true });
      setTimeout(function () { pending.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
    }

    /* ---------- sticky bar: after the main button scrolls away, hidden near the final CTA ---------- */
    var sticky = root.querySelector('[data-dcl-sticky]');
    var anchor = root.querySelector('[data-dcl-cta-anchor]');
    var fin = root.querySelector('[data-dcl-final]');
    if (sticky && anchor && hasIO) {
      var past = false, finVis = false;
      var upd = function () {
        var on = past && !finVis;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        var link = sticky.querySelector('a');
        if (link) link.tabIndex = on ? 0 : -1;
      };
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { past = !e.isIntersecting && e.boundingClientRect.top < 0; });
        upd();
      }).observe(anchor);
      if (fin) new IntersectionObserver(function (es) {
        es.forEach(function (e) { finVis = e.isIntersecting; });
        upd();
      }).observe(fin);
    }
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-dcl]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();